(function () {
  var versions = new WeakMap();
  var cartRevision = 0;
  function choose(manual, related, excluded, limit) {
    var seen = new Set(excluded.map(String));
    return manual.concat(related).filter(function (node) {
      var id = node.dataset.ggProductAddon;
      if (!id || seen.has(id)) return false;
      seen.add(id); return true;
    }).slice(0, limit);
  }
  function render(root, nodes) {
    root.querySelector('.gg-product-addons__items').replaceChildren.apply(root.querySelector('.gg-product-addons__items'), nodes.map(function (node) { return node.cloneNode(true); }));
    root.hidden = nodes.length === 0;
    root.querySelector('.gg-product-addons__controls').hidden = nodes.length < 2;
  }
  async function update(root, cartIds) {
    var version = (versions.get(root) || 0) + 1;
    versions.set(root, version);
    var excluded = cartIds.concat([root.dataset.ggProduct]);
    var limit = Math.min(4, Math.max(1, Number(root.dataset.ggLimit) || 3));
    var manual = Array.from(root.querySelectorAll('template')).map(function (template) { return template.content.querySelector('[data-gg-product-addon]'); }).filter(Boolean);
    render(root, choose(manual, [], excluded, limit));
    if (root.dataset.ggAuto !== 'true' || choose(manual, [], excluded, limit).length >= limit) return;
    try {
      var base = window.Shopify?.routes?.root || '/';
      var response = await fetch(base + 'recommendations/products?section_id=geekery-product-related&product_id=' + encodeURIComponent(root.dataset.ggProduct) + '&limit=10&intent=related', { credentials: 'same-origin' });
      if (!response.ok) return;
      var html = await response.text();
      var related = Array.from(new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-gg-product-addon]'));
      if (root.isConnected && versions.get(root) === version) render(root, choose(manual, related, excluded, limit));
    } catch (error) { /* Manual recommendations remain usable if Shopify is unavailable. */ }
  }
  async function add(button) {
    if (button.disabled) return;
    var card = button.closest('.gg-product-addon');
    var select = card.querySelector('.gg-product-addon__variant');
    var id = select ? select.value : button.dataset.ggAddVariant;
    var errorNode = card.querySelector('.gg-product-addon__error');
    button.disabled = true; button.textContent = 'Adding…'; errorNode.hidden = true;
    try {
      var response = await fetch((window.routes?.cartAddUrl || '/cart/add') + '.js', {
        credentials: 'same-origin', method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added. Please try again.');
      // Let Warehouse update the drawer/count, and let the existing preorder notice run.
      button.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { button: button, quantity: 1, productAdded: true } }));
      if (window.theme?.cartType === 'page') window.location.href = window.routes.cartUrl;
    } catch (error) {
      errorNode.textContent = error.message || 'This item could not be added. Please try again.';
      errorNode.hidden = false;
    } finally {
      button.disabled = false; button.textContent = '+ Add';
    }
  }
  function init(scope) {
    var roots = Array.from(scope.querySelectorAll('[data-gg-product-addons]'));
    if (scope.matches?.('[data-gg-product-addons]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (!root.dataset.ggInitialized) {
        root.dataset.ggInitialized = 'true';
        root.addEventListener('click', function (event) {
          var button = event.target.closest('[data-gg-add-variant]');
          if (button) { event.preventDefault(); event.stopPropagation(); add(button); return; }
          var direction = event.target.closest('[data-gg-addon-prev]') ? -1 : event.target.closest('[data-gg-addon-next]') ? 1 : 0;
          if (direction) { var items = root.querySelector('.gg-product-addons__items'); items.scrollBy({ left: direction * items.clientWidth, behavior: 'smooth' }); }
        });
        root.addEventListener('change', function (event) {
          if (!event.target.matches('.gg-product-addon__variant')) return;
          event.target.closest('.gg-product-addon').querySelector('.gg-product-addon__price').textContent = event.target.selectedOptions[0].dataset.ggPrice;
        });
      }
      var ids; try { ids = JSON.parse(root.dataset.ggCartProducts || '[]'); } catch (error) { ids = []; }
      update(root, ids);
    });
  }
  async function refresh() {
    var roots = Array.from(document.querySelectorAll('[data-gg-product-addons]'));
    if (!roots.length) return;
    var revision = ++cartRevision;
    roots.forEach(function (root) { versions.set(root, (versions.get(root) || 0) + 1); });
    try {
      var response = await fetch((window.routes?.cartUrl || '/cart') + '.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      var cart = await response.json();
      if (revision !== cartRevision) return;
      var ids = cart.items.map(function (item) { return item.product_id; });
      document.querySelectorAll('[data-gg-product-addons]').forEach(function (root) { update(root, ids); });
    } catch (error) { /* Keep checkout and existing suggestions usable. */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('cart:rerendered', refresh, true);
})();
